const routes = [
  //医疗数据中心
  {
    path: "/medicaldataCenter",
    name: 'medicaldataCenter',
    meta: {
      title: '数据概览',
      hasBack: false
    },
    component: () => import('@/pages/medical/medicaldataCenter/medicalOverview.vue'),
  },

];
export default routes;